import {Component, OnInit} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslatePipe} from "@ngx-translate/core";

@Component({
    selector: 'app-beta-notice',
    standalone: true,
    imports: [FormsModule, TranslatePipe],
    templateUrl: './beta-notice.component.html',
    styleUrls: ['./beta-notice.component.scss']
})
export class BetaNoticeComponent implements OnInit {
    isVisible = false;
    doNotShowAgain = false;

    private readonly storageKey = 'betaNoticeDismissed';

    ngOnInit(): void {
        this.isVisible = !this.isNoticeDismissed();
    }

    dismissNotice(): void {
        if (this.doNotShowAgain) {
            this.setNoticeDismissed();
        }
        this.isVisible = false;
    }

    private isNoticeDismissed(): boolean {
        return localStorage.getItem(this.storageKey) === 'true';
    }

    private setNoticeDismissed(): void {
        localStorage.setItem(this.storageKey, 'true');
    }
}